<template>
    <h1>{{ trans.minimumAgePopover.title }}</h1>
    <p>{{ text }}</p>
    <div class="btns">
        <div class="split">
            <button class="btn cancel" @click="onCancel">{{ trans.minimumAgePopover.cancel }}</button>
        </div>
        <div class="split">
            <button class="btn" @click="onConfirm">{{ trans.minimumAgePopover.confirm }}</button>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";

    import { replaceString } from "@/data/util/String";

    import { trans } from "@/app/localization/Trans";

    const props = defineProps<{
        age: number;
        confirm: () => void;
        hide: () => void;
    }>();

    const text = computed(() => replaceString(trans.minimumAgePopover.text, props.age + ""));

    function onCancel() {
        props.hide();
    }

    function onConfirm() {
        props.confirm();
        props.hide();
    }
</script>
